import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import type { FocusEventHandler } from 'react';
import { locationService, type City } from '@/services/location.service';

interface Props {
  value?: string;
  onChange: (cityId: string) => void;
  onChangeWithLabel?: (cityId: string, name: string) => void;
  placeholder?: string;
  status?: 'error' | 'warning';
  allowClear?: boolean;
  disabled?: boolean;
  // Forwarded so FloatingField can toggle the floating-label state.
  onFocus?: FocusEventHandler<HTMLElement>;
  onBlur?: FocusEventHandler<HTMLElement>;
}

export function CityAsyncSelect({
  value,
  onChange,
  onChangeWithLabel,
  placeholder = 'Chọn tỉnh/thành phố',
  status,
  allowClear = true,
  disabled,
  onFocus,
  onBlur,
}: Props) {
  const { data = [], isLoading, isError } = useQuery({
    queryKey: ['locations', 'cities'],
    queryFn: locationService.listCities,
    staleTime: 30 * 60 * 1000,
  });

  const options = data.map((c: City) => ({ value: c.city_id, label: c.name }));

  return (
    <Select
      style={{ width: '100%' }}
      size="small"
      showSearch
      optionFilterProp="label"
      placeholder={isError ? 'Lỗi tải danh sách...' : placeholder}
      value={value || undefined}
      loading={isLoading}
      options={options}
      allowClear={allowClear}
      disabled={disabled || isError}
      status={isError ? 'error' : status}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(v: string) => {
        onChange(v ?? '');
        if (onChangeWithLabel) {
          const found = options.find((o) => o.value === v);
          onChangeWithLabel(v ?? '', found?.label ?? '');
        }
      }}
    />
  );
}
